import { Controller } from "@hotwired/stimulus";

// Handles campaign/ad-group checkbox mutual exclusivity on the bid calculator form.
// Each campaign row is a controller instance. Checking the campaign unchecks its ad groups
// and vice versa.
export default class extends Controller {
  static targets = ["campaignCheckbox", "adGroupCheckbox", "adGroupRow"];
  static values = { campaignId: Number };

  campaignToggled() {
    if (this.campaignCheckboxTarget.checked) {
      this.adGroupCheckboxTargets.forEach((cb) => (cb.checked = false));
    }
  }

  adGroupToggled() {
    const anyAdGroupChecked = this.adGroupCheckboxTargets.some((cb) => cb.checked);
    if (anyAdGroupChecked) {
      this.campaignCheckboxTarget.checked = false;
    }
  }
}
